const getters = {
  getGrapChannels(state) {
    return state.themes.grapChannels;
  },
};

export default getters;
